<template>
  <div class="dashboard-container">
    <!-- 客资管理 -->
    <div class="app-container">
      <el-card shadow="never">
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-button type="primary" size="small" @click="add" icon="el-icon-plus" class="btns">新增模板</el-button>
          </el-form-item>
        </el-form>
        <el-table
          :header-cell-style="{
            background: '#fafafa'
          }"
          :data="list"
          border
          style="width: 100%;"
          v-loading="listLoading"
        >
          <el-table-column label="模板名称" prop="templateName" header-align="center"></el-table-column>
          <el-table-column label="模板是否可上传文件" header-align="center" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.templateType === 1">是</span>
              <span v-if="scope.row.templateType === 2">否</span>
            </template>
          </el-table-column>
          <el-table-column label="模板状态" header-align="center" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.templateStatus === 1">启用</span>
              <span v-if="scope.row.templateStatus === 2">失效</span>
            </template>
          </el-table-column>

          <el-table-column prop="createTime" label="创建时间" header-align="center" align="center"></el-table-column>
          <el-table-column
            fixed="right"
            prop="address"
            header-align="center"
            label="操作"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row.templateId)">编辑</el-button>
              <el-button type="text" @click="detail(scope.row.templateId)">详情</el-button>
              <el-button type="text" @click="deleteTemplate(scope.row.templateId)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <template-add ref="templateAdd" @refreshTemplate="refreshTemplate"></template-add>
        <template-upd ref="templateUpd" @refreshTemplate="refreshTemplate"></template-upd>
        <template-det ref="templateDet"></template-det>
      </el-card>
    </div>
  </div>
</template>

<script>

import apiBaseUrl from "../../../config/api";
import axios from "axios";
import TemplateAdd from "./TemplateAdd.vue";
import TemplateUpd from "./TemplateUpd.vue";
import TemplateDet from "./TemplateDet.vue";

export default {
  components: {TemplateDet, TemplateUpd, TemplateAdd},

  data() {
    return {
      template: {
        templateStatus: null,
      },
      list: [],
      listLoading: false, //加载样式
    };
  },
  computed: {},
  watch: {},
  methods: {
    //添加模板
    add() {
      this.$nextTick(() => {
        this.$refs.templateAdd.init()
      })
    },
    listData() {
      this.listLoading = true

      axios
        .post(`${apiBaseUrl}/template/page`,this.template,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          if (res.data.code === 200) {
            this.list = res.data.data
            this.listLoading = false
          } else {
            this.$message({
              message: res.data.message,
              type: 'error'
            })
          }
        })
    },
    refreshTemplate() {
      this.listData()
    },
    deleteTemplate(id) {
      this.$confirm(`确定删除这个模板吗？<span style="color: red">删除的模板不可恢复!</span>`, `提示`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        type: "warning"
      }).then(() => {
        axios
          .delete(`${apiBaseUrl}/template/delete/${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then(res => {
            if (res.data.code === 200) {
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.listData()
            } else {
              this.$message({
                message: '删除失败',
                type: 'error'
              })
            }
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作',
        })
      })
    },
    //编辑
    edit(id) {
      this.$nextTick(() => {
        this.$refs.templateUpd.init(id)
      })
    },
    //详情
    detail(id) {
      this.$nextTick(() => {
        this.$refs.templateDet.init(id)
      })
    }
  },
  beforeCreate() {
  },

  created() {
    this.listData()
  },

  beforeMount() {

  },

  mounted() {

  },

  beforeUpdate() {

  },

  updated() {

  },

  beforeDestroy() {

  },
  destroyed() {

  },

  activated() {

  },
}


</script>

<style scoped>
.demo-form-inline {
  height: 35px;
  display: flex;
  margin-bottom: 10px;
  float: right;
}
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}
</style>




// WEBPACK FOOTER //
// src/manager/components/TemplateSet.vue